module.exports = __webpack_public_path__ + "media/images/home-banners/zen-2040340_1920-3b7d3414b38183b38b9cc64e3a540f55.jpg";